import React, { useEffect } from 'react'
import OptionDialog from "../Dialogs/OptionDialog"

export default function ShoppinglistOptions({
    listId, 
    title, 
    showDialog,
    isSharedWithUser = false,
    canEdit = false, 
    onAction = () => {},
    onCancel = () => {}
}) {
    const options = []

    options.push({ id: 'report', label: 'report prices', disabled: true})

    if (!isSharedWithUser) {
        options.push({ id: 'delete', label: 'delete list'})
    }

    if (isSharedWithUser) {
        options.push({ id: 'remove', label: 'remove list'})
    }

    if (canEdit) {
        options.push({ id: 'edit', label: 'edit list'})
    } 
    options.push({ id: 'shop', label: 'start shop'})

    if (!isSharedWithUser) {
        options.push({ id: 'share', label: 'share list'})
    }

    options.push({ id: 'clipboard', label: 'copy items'})
    
    const handleOnOptionSelect = (selection) => {
        onAction(selection, listId)
    }

    if (!showDialog) {
        return (<></>)
    }

    return (
        <>
            <OptionDialog
                processing={false}
                options={options}
                title={title}
                onSelect={handleOnOptionSelect} 
                showDialog={showDialog}
                onCancel={() => { onCancel() }}
            />
        </>
    )
}